import { useTranslation } from "react-i18next";

export default function Breadcrumb() {
  const { t } = useTranslation("slot-cilinder-vervangen");

  return (
    <nav className="bg-brand-cream border-b border-brand-border" aria-label="Breadcrumb">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-3">
        <ol className="flex items-center gap-2 font-geist text-sm text-brand-text/60 flex-wrap">
          <li>
            <a href="/" className="hover:text-brand-blue transition-colors whitespace-nowrap">
              {t("breadcrumb.home")}
            </a>
          </li>
          <li className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-xs"></i>
          </li>
          <li>
            <a href="/onze-diensten/" className="hover:text-brand-blue transition-colors whitespace-nowrap">
              {t("breadcrumb.diensten")}
            </a>
          </li>
          <li className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-xs"></i>
          </li>
          <li className="text-brand-text font-medium whitespace-nowrap">
            {t("breadcrumb.current")}
          </li>
        </ol>
      </div>
    </nav>
  );
}